export class BingoNpmParams {
    isDll: boolean;
    disableSchedulePostCall: boolean;
    disableSlotracesCallsOnBootstrap: boolean;
    nodeEnvironment: string;
    localEnvironment: string;
}
